import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import EmptyStateIllustration from 'Pods/ThreeDStudio/Shared/EmptyStateIllustration/EmptyStateIllustration'

import { NOOP } from 'Utils/stableDefaults'

function EmptyState({ hasActiveFilters = false, onClearFilters = NOOP }) {
  const t = useTranslation()

  return (
    <div className="community-gallery-empty-state" role="status">
      <div className="community-gallery-empty-state__content">
        <EmptyStateIllustration />
        <div className="community-gallery-empty-state__text">
          <p className="community-gallery-empty-state__title cgt-heading-300">
            {t('imageGallery.empty.title')}
          </p>
          <p className="community-gallery-empty-state__description cgt-body-md">
            {t('imageGallery.empty.description')}
          </p>
        </div>
      </div>
      {hasActiveFilters && (
        <div className="community-gallery-empty-state__actions">
          <Button type="secondary" size="small" onClick={onClearFilters}>
            {t('imageGallery.empty.clearFilters')}
          </Button>
        </div>
      )}
    </div>
  )
}

EmptyState.propTypes = {
  hasActiveFilters: bool,
  onClearFilters: func,
}

export default EmptyState
